import React from "react";
import Chat from "../../feature-module/application/components/chat/chat";
import { useTabVisibility } from "../../hooks/useTabVisibility";

interface ChatTabProps {
    tenant_id?: number | string | null;
    contact_id?: number | string | null;
    isContactPage?: boolean;
    lifecycleName?: string;
}

const ChatTab: React.FC<ChatTabProps> = ({
    tenant_id,
    contact_id,
    isContactPage,
    lifecycleName,
}) => {
    const { hasBeenActivated } = useTabVisibility({ tabId: "chat" });

    return (
        <div className="tab-pane" id="chat">
            <div className="card">
                {!hasBeenActivated ? null : !contact_id && lifecycleName ? (
                    <div className="text-center p-4 text-muted">
                        Contact is not assigned to this {lifecycleName}
                    </div>
                ) : (
                    <Chat
                        tenant_id={tenant_id}
                        contact_id={contact_id}
                        isContactPage={isContactPage}
                    />
                )}
            </div>
        </div>
    );
};

export default ChatTab;
